import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import AccordionFilterSelect from "../accordion/AccordionFilterSelect";
import { SortNFilter } from "../search/SortNFilter";
import MediaQuery from "react-responsive";
export var RetailHeading = function RetailHeading(props) {
  var heading = props.heading,
      label = props.label,
      CategoryArray = props.CategoryArray,
      sortByChange = props.sortByChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1]; // heading is now derived from final path


  var header;

  if (typeof window !== 'undefined') {
    var _window, _window$location;

    header = ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname.split("/").pop().split("-").join(" ")) || "Not Found";
  }

  return /*#__PURE__*/React.createElement(Row, {
    className: "cb-retail__landing-heading"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-search-header"
  }, /*#__PURE__*/React.createElement("strong", null, header)), /*#__PURE__*/React.createElement("h3", {
    className: "cb-type-body-1 cb-search-label"
  }, label)), /*#__PURE__*/React.createElement(Col, {
    lg: "3"
  }), /*#__PURE__*/React.createElement(Col, {
    lg: "3"
  }, /*#__PURE__*/React.createElement(AccordionFilterSelect, {
    categories: CategoryArray,
    changeHandler: function changeHandler(e) {
      e.persist();
      sortByChange(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-search-header"
  }, /*#__PURE__*/React.createElement("strong", null, header)), /*#__PURE__*/React.createElement("h3", {
    className: "cb-type-body-1 cb-search-label"
  }, label)), /*#__PURE__*/React.createElement(Col, {
    md: "12"
  }, /*#__PURE__*/React.createElement("button", {
    className: "cb-button-secondary",
    onClick: function onClick() {
      return setShow(true);
    }
  }, "Sort and Filter")), /*#__PURE__*/React.createElement(SortNFilter, _extends({}, props, {
    show: show,
    close: function close() {
      return setShow(false);
    },
    categories: CategoryArray
  }))));
};